import type { IAuditoriaEventoGrupo } from "@/api/space/dtos/authenticator.dto";
import { agruparAuditoriaPorDia } from "../auditoria.utils";
import DiaAuditoria from "./DiaAuditoria";
import EsqueletoAuditoriaGrupo from "../../../skeleton/EsqueletoAuditoriaGrupo";
import EstadoVazioAuditoria from "./EstadoVazioAuditoria";

export default function ListaAuditoria({
	itens,
	carregando,
	temFiltro,
}: {
	readonly itens: IAuditoriaEventoGrupo[];
	readonly carregando: boolean;
	readonly temFiltro: boolean;
}) {
	if (carregando) return <EsqueletoAuditoriaGrupo />;
	if (itens.length === 0) return <EstadoVazioAuditoria temFiltro={temFiltro} />;

	const dias = agruparAuditoriaPorDia(itens);

	return (
		<div className="flex flex-col gap-3">
			{dias.map((dia, indice) => (
				<DiaAuditoria key={dia.chave} dia={dia} defaultAberto={indice === 0} />
			))}
		</div>
	);
}
